"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

import { useInvalidateCommunityQueries } from "./utils/useInvalidateCommunityQueries";

const urlBackendPath = "/communities/{community_id}/members/{user_id}" as const;

/**
 * Removes a single member from a community (DELETE, no body). Used to reject a
 * pending join request. On success it invalidates the community queries so the
 * admin/member/requests lists and their counts refresh.
 */
export const useRequestCommunityMemberDelete = ({
  id,
  ...props
}: { id: number } & Partial<
  UseOpenApiMutationOptions<typeof urlBackendPath, "DELETE">
>) => {
  const invalidateCommunityQueries = useInvalidateCommunityQueries({ id });

  return useOpenApiMutation({
    ...props,
    method: "DELETE",
    onSuccess: async (data, variables, context) => {
      await invalidateCommunityQueries();
      props.onSuccess?.(data, variables, context);
    },
    urlBackendPath,
  });
};
